const base = {
    path: 'base',
    component: resolve => require(['@/pages/admin/user_info/base'], resolve)
}

export default base